export const isAvcoderTaskStartable = (state: 'STOPPED' | 'COMPLETED' | 'STOPPING' | 'FAILED' | string) =>
  ['STOPPED', 'COMPLETED', 'STOPPING', 'FAILED'].includes(state)
